export default __webpack_public_path__ + "static/corporate-training-b737970d41dd90278b7706c6fb460603.webp";